import 'angular:locale/data:pl';
import 'angular:locale/data:de';
import 'angular:locale/data:es';
import 'angular:locale/data:fr';
import 'angular:locale/data:en';
import 'angular:locale/data:it';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
